/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayerScoreStatistic
 */
export interface PlayerScoreStatistic {
    /**
     * 
     * @type {string}
     * @memberof PlayerScoreStatistic
     */
    playerId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerScoreStatistic
     */
    playerName?: string;
    /**
     * 
     * @type {number}
     * @memberof PlayerScoreStatistic
     */
    playerNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlayerScoreStatistic
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerScoreStatistic
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerScoreStatistic
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerScoreStatistic
     */
    categoryName?: string;
    /**
     * 
     * @type {number}
     * @memberof PlayerScoreStatistic
     */
    goals?: number;
    /**
     * 
     * @type {number}
     * @memberof PlayerScoreStatistic
     */
    matchesPlayed?: number;
    /**
     * 
     * @type {number}
     * @memberof PlayerScoreStatistic
     */
    goalsPerMatch?: number;
}

/**
 * Check if a given object implements the PlayerScoreStatistic interface.
 */
export function instanceOfPlayerScoreStatistic(value: object): value is PlayerScoreStatistic {
    return true;
}

export function PlayerScoreStatisticFromJSON(json: any): PlayerScoreStatistic {
    return PlayerScoreStatisticFromJSONTyped(json, false);
}

export function PlayerScoreStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerScoreStatistic {
    if (json == null) {
        return json;
    }
    return {
        
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'playerNumber': json['playerNumber'] == null ? undefined : json['playerNumber'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'goals': json['goals'] == null ? undefined : json['goals'],
        'matchesPlayed': json['matchesPlayed'] == null ? undefined : json['matchesPlayed'],
        'goalsPerMatch': json['goalsPerMatch'] == null ? undefined : json['goalsPerMatch'],
    };
}

export function PlayerScoreStatisticToJSON(json: any): PlayerScoreStatistic {
    return PlayerScoreStatisticToJSONTyped(json, false);
}

export function PlayerScoreStatisticToJSONTyped(value?: PlayerScoreStatistic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerId': value['playerId'],
        'playerName': value['playerName'],
        'playerNumber': value['playerNumber'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'goals': value['goals'],
        'matchesPlayed': value['matchesPlayed'],
        'goalsPerMatch': value['goalsPerMatch'],
    };
}

